// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const armory = defineModel({
  id: "armory",
  batchId: "future",
  name: "Armory",
  tags: ["building","armory","low-poly","age-of-mcp","future","military"],
  summary: "An armory storing weapons and armour for a settlement's defenders.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.5,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(0.92, 0.14, 0.92), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(0.92, 0.14, 0.92), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.82, 0.4, 0.82), color: "#807870", position: [0, 0.34, 0] },
      { geometry: new THREE.BoxGeometry(0.86, 0.06, 0.86), color: "#615a52", position: [0, 0.2, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [-0.435, 0.35, -0.435] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [0.435, 0.35, -0.435] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [-0.435, 0.35, 0.435] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [0.435, 0.35, 0.435] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(0.92, 0.14, 0.92), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.82, 0.7, 0.82), color: "#807870", position: [0, 0.49, 0] },
      { geometry: new THREE.BoxGeometry(0.86, 0.06, 0.86), color: "#615a52", position: [0, 0.2, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [-0.435, 0.5, -0.435] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [0.435, 0.5, -0.435] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [-0.435, 0.5, 0.435] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [0.435, 0.5, 0.435] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(0.92, 0.14, 0.92), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.82, 0.7, 0.82), color: "#807870", position: [0, 0.49, 0] },
      { geometry: new THREE.BoxGeometry(0.86, 0.06, 0.86), color: "#615a52", position: [0, 0.2, 0] },
      { geometry: new THREE.BoxGeometry(0.94, 0.06, 0.528394), color: "#4a5258", position: [0, 0.97, 0.23], rotation: [0.514451, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.94, 0.06, 0.528394), color: "#4a5258", position: [0, 0.97, -0.23], rotation: [-0.514451, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.96, 0.06, 0.06), color: "#3c4146", position: [0, 1.1, 0] },
      { geometry: new THREE.BoxGeometry(0.3, 0.46, 0.05), color: "#4a3a2a", position: [0, 0.37, 0.42] },
      { geometry: new THREE.BoxGeometry(0.32, 0.04, 0.06), color: "#3c4146", position: [0, 0.5, 0.422] },
      { geometry: new THREE.BoxGeometry(0.32, 0.04, 0.06), color: "#3c4146", position: [0, 0.26, 0.422] },
      { geometry: new THREE.CylinderGeometry(0.1, 0.12, 0.03, 6), color: "#9d3530", position: [0, 0.76, 0.43], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.04, 0.4, 0.04), color: "#6f4a26", position: [0.45, 0.34, -0.2] },
      { geometry: new THREE.CylinderGeometry(0.007, 0.007, 0.5, 4), color: "#6f4a26", position: [0.47, 0.39, -0.26], rotation: [0.1, 0, -0.15] },
      { geometry: new THREE.CylinderGeometry(0.007, 0.007, 0.5, 4), color: "#6f4a26", position: [0.47, 0.39, -0.2], rotation: [0.1, 0, -0.15] },
      { geometry: new THREE.CylinderGeometry(0.007, 0.007, 0.5, 4), color: "#6f4a26", position: [0.47, 0.39, -0.14], rotation: [0.1, 0, -0.15] },
      { geometry: new THREE.ConeGeometry(0.02, 0.07, 4), color: "#9aa0a6", position: [0.54, 0.64, -0.2] },
      { geometry: new THREE.CylinderGeometry(0.1, 0.1, 0.03, 6), color: "#3d6ea0", position: [-0.46, 0.26, 0.2], rotation: [1.570796, 0, 0.3] },
      { geometry: new THREE.CylinderGeometry(0.1, 0.1, 0.03, 6), color: "#9d3530", position: [-0.5, 0.26, 0.05], rotation: [1.570796, 0, 0.3] },
    ] },
  ],
  animations: [],
});
